import type { AccountType } from "./auth";

export const hospitalBrand = {
  logo: "/mdn.png",
  profile: "/mdn-2.png",
  alt: "Medecin de nuit",
} as const;

export const enterpriseBrand = {
  logo: "/CEEC.jpg",
  profile: "/CEEC.jpg",
  alt: "CEEC",
} as const;

/** Plus de photo mockée par rôle — avatar = initiales (sauf photo utilisateur réelle plus tard). */
export const accountProfileImages: Partial<Record<AccountType, string>> = {};

export const accountAvatarInitials: Record<AccountType, string> = {
  admin: "AD",
  auditor: "AU",
  hospital: "HO",
  enterprise: "EN",
};

export function initialsFromName(name: string | null | undefined): string | null {
  const parts = (name ?? "")
    .trim()
    .split(/\s+/)
    .filter(Boolean);
  if (parts.length === 0) return null;
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return `${parts[0][0] ?? ""}${parts[parts.length - 1][0] ?? ""}`.toUpperCase();
}

export function getAccountAvatarInitials(
  accountType: AccountType | null,
  displayName?: string | null,
) {
  const fromName = initialsFromName(displayName);
  if (fromName) return fromName;
  if (!accountType) return "SC";
  return accountAvatarInitials[accountType];
}

export function getAccountProfileImage(_accountType: AccountType | null) {
  return undefined;
}
